import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4a298e38&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a298e38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a298e38')) {
      api.createRecord('4a298e38', component.options)
    } else {
      api.reload('4a298e38', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4a298e38&scoped=true", function () {
      api.rerender('4a298e38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistic/transaction/index.vue"
export default component.exports